import React, {useEffect, useRef, useState} from 'react';

// 이미지 임포트 (실제 이미지 경로로 변경 필요)
import stores from '../../../assets/images/about/section_02_subsection_06_item_01.png';

const AboutSubSection0204: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거 // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className={`container text-black pt-[105px] pb-[70px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="hidden lg:block mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 이미지, 오른쪽 텍스트 */}
        <div className="flex flex-row items-center justify-between lg:gap-8 xl:gap-16 2xl:gap-32">
          {/* 왼쪽: 이미지 */}
          <div className="w-1/2 2xl:w-2/5">
            <img
              src={stores}
              alt="오프라인 스토어 이미지 1"
              className="w-full max-w-[676px] object-cover rounded-[5px]"
            />
          </div>

          {/* 오른쪽: 텍스트 정보 */}
          <div className="w-1/2 2xl:w-2/5">
            {/* 섹션 제목 */}
            <p className="text-xl font-semibold mb-[72px]">
              Japan Distribution & Marketing
            </p>
            <p className="text-40 leading-[1.4] font-bold mb-[72px]">
              일본 현지 법인과 함께<br/>
              유통·마케팅 전 과정을 통합 운영
            </p>
            <p className="text-xl font-normal leading-[1.6]">
              현지 파트너 법인 株式会社ANW 사를 통해 일본 내 온·오프라인 유통과 마케팅을 실행합니다.<br/>
              약 8,500개 오프라인 채널과 주요 EC채널을 포함한<br/>
              10개 이상의 온라인 플랫폼 연계를 지원합니다.
            </p>
          </div>
        </div>
      </div>
      <div className="lg:hidden mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 텍스트, 오른쪽 이미지 */}
        <div className="flex flex-col items-center justify-center">
          {/* 왼쪽: 통계 정보 */}
          <p className="text-2xl md:text-4xl font-semibold mb-[30px] md:mb-[50px]">
            Japan Distribution License
          </p>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold md:mb-4">
              일본 현지 법인과 함께
          </span>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold">
              유통·마케팅 전 과정을 통합 운영
          </span>

          <img
            src={stores}
            alt="폰뷰 앱 화면"
            className="w-4/6 h-auto py-20 md:py-28"
          />

          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            현지 파트너 법인 株式会社ANW 사를 통해 일본 내</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            온·오프라인 유통과 마케팅을 실행합니다.</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            약 8,500개 오프라인 채널과 주요 EC채널을 포함한</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            10개 이상의 온라인 플랫폼 연계를 지원합니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSubSection0204;